<template>
  <div class="row skill">
    <div class="col-12">
      <span class="bonus">
        {{ passiveBonus() }}
      </span>
      <label class="name clipper trained">
        Passive {{ item.name }} <span class="capitalize c5">({{ attributeName }})</span>
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: "sheet-skills-passive",
  props: ["item", "attribute", "skillBonus"],
  computed: {
    attributeName() {
      return this.item.attribute.substring(0, 3);
    }
  },
  methods: {
    passiveBonus() {
      let passiveMisc =
        isFinite(this.item.passiveMisc) && this.item.passiveMisc !== ""
          ? this.item.passiveMisc
          : 0;

      return this.skillBonus + passiveMisc + 10;
    }
  }
};
</script>
